import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, nextTick, ref, watch } from 'vue';
import GlobalNotification from '@/modules/Notifications/components/GlobalNotification.vue';
import { NotificationField } from '@/modules/Notifications/interfaces/Notification';
import { TimeSplitNotifications } from '@/modules/Notifications/interfaces/TimeSplitNotification';
import Notification from '@/modules/Notifications/api/models/Notification';
import NotificationRepository from '@/modules/Notifications/api/repositories/NotificationRepository';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';
import store from '@/store';

interface Props {
    notificationsVisible: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalNotificationsPopup',
  props: {
    notificationsVisible: { type: Boolean }
  },
  emits: ["toggleNotifications", "refreshUnreadCount"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'toggleNotifications'): void;
    (e: 'refreshUnreadCount'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    notificationsVisible: boolean;
};




const { proxy } = getCurrentInstance()!;

const hideReadMessages = ref(false);
const loadingOverlay = new LoadingOverlayHelper(proxy, {});

const unreadCount = computed(() => store.getters['generic/unreadNotificationsCount']);

const notifications = computed((): NotificationField[] => NotificationRepository.getAll());

const timeSplitNotifications = computed((): TimeSplitNotifications => {
    const arr: TimeSplitNotifications = {};

    notifications.value.forEach((notification: NotificationField) => {
        let creationTime = '';

        const notificationDate = new Date(notification.createdAt);

        switch (true) {
            case checkIfDateIsOlderByDay(0, notificationDate):
                creationTime = 'Today';
                break;
            case checkIfDateIsOlderByDay(1, notificationDate):
                creationTime = 'Yesterday';
                break;
            default:
                creationTime = 'Older';
        }

        if (!notification.readAt || (notification.readAt && !hideReadMessages.value)) {
            if (arr[creationTime]) {
                arr[creationTime].push({ ...notification });
            } else {
                arr[creationTime] = [{ ...notification }];
            }
        }
    });

    return arr;
});

const isAnyUnread = computed(() => unreadCount.value > 0);

async function switchNotificationsByReadState() {
    loadingOverlay.start();

    try {
        if (hideReadMessages.value) {
            await Notification.getUnread();
        } else {
            await Notification.getAll();
        }
    } catch {
        proxy?.$notification.error({
            message: proxy?.$t('Error updating notifications') as string,
            description: '',
        });
    } finally {
        toggleResize();
        loadingOverlay.stop();
    }
}

function toggleResize() {
    setTimeout(() => {
        emit('toggleNotifications');
    }, 0);
}

function updateReadStatus() {
    // const notification = notifications.value.find((notification: NotificationField) => {
    //     return notification.id === id;
    // });

    // if (notification) {
    //     notification.readAt = true;
    // }
    return;
}

async function markAllAsRead() {
    loadingOverlay.start();

    try {
        await Notification.updateAllAsRead();
    } catch {
        proxy?.$notification.error({
            message: proxy?.$t('Error updating notifications') as string,
            description: '',
        });
    } finally {
        loadingOverlay.stop();
    }
}

function checkIfDateIsOlderByDay(days: number, notificationDate: Date) {
    const currentDate = new Date();

    return (
        notificationDate.getDate() === currentDate.getDate() - days &&
        notificationDate.getMonth() === currentDate.getMonth() &&
        notificationDate.getFullYear() === currentDate.getFullYear()
    );
}

async function updateNotifications(isVisible: boolean) {
    if (!isVisible) {
        return;
    }

    loadingOverlay.start();

    try {
        if (isAnyUnread.value) {
            await markAllAsRead();
            emit('refreshUnreadCount');
        }

        await nextTick();
        await Notification.getAll();
    } catch {
        proxy?.$notification.error({
            message: proxy?.$t('Error updating notifications') as string,
            description: '',
        });
    } finally {
        loadingOverlay.stop();
    }

    toggleResize();
}

watch(() => props.notificationsVisible, updateNotifications, { immediate: true });

return { __sfc: true,props, emit, proxy, hideReadMessages, loadingOverlay, unreadCount, notifications, timeSplitNotifications, isAnyUnread, switchNotificationsByReadState, toggleResize, updateReadStatus, markAllAsRead, checkIfDateIsOlderByDay, updateNotifications, GlobalNotification }
}

})